import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { clientConfig } from 'pos-client/clientConfig.ts';
import { useCurrentUser } from 'pos-client/hooks/useCurrentUser.ts';

const trackUserSession = (userIdentifier: string) => {
  datadogRum.setUser({
    id: userIdentifier,
  });
};

export const DatadogUserTracking = () => {
  const { currentUser } = useCurrentUser();
  const isDatadogUserTrackingEnabled =
    clientConfig.datadog.enabled && clientConfig.datadog.allowUserTracking;
  useEffect(() => {
    if (isDatadogUserTrackingEnabled && currentUser) {
      trackUserSession(currentUser.id);
    }
  }, [currentUser]);
  return null;
};
